import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

import {
  Modal,
  LoaderIndicator,
  HelperViewStatus,
  HeadingDisplay,
  Heading,
  Row,
  ChipStatus,
  ButtonContainer,
  ButtonPrimary,
  BaseIcon,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';
import {
  getProductDetails,
  IProductDetails
} from '@/modules/catalog/services/products';

interface Props {
  isOpen: boolean;
  productApiId: string;
  isLoadingButton: boolean;
  canAdd: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetails',
  props: {
    isOpen: { type: Boolean },
    productApiId: null,
    isLoadingButton: { type: Boolean },
    canAdd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  productApiId: string;
  isLoadingButton: boolean;
  canAdd: boolean;
}



const product = ref<IProductDetails | null>(null);
const isLoading = ref(false);
const hasError = ref(false);

const mapLevelRisk: { [key: string]: { status: string; text: string } } = {
  LOW: { status: 'positive', text: 'Baixo' },
  MEDIUM: { status: 'alert', text: 'Médio' },
  HIGH: { status: 'negative', text: 'Alto' }
};

const riskDetails = computed(() => {
  return mapLevelRisk[product.value?.risk.value || ''];
});

watch(
  () => props.productApiId,
  async () => {
    if (!props.productApiId) {
      return;
    }

    await fetchProductDetails();
  },
  { immediate: true }
);

async function fetchProductDetails() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const instrumentType =
      WarrenSession.get(StorageKeys.ProductCatalogType) || 'fixed-income';

    product.value = await getProductDetails(props.productApiId, instrumentType);
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,props, product, isLoading, hasError, mapLevelRisk, riskDetails, fetchProductDetails, Modal, LoaderIndicator, HelperViewStatus, HeadingDisplay, Heading, Row, ChipStatus, ButtonContainer, ButtonPrimary, BaseIcon, BaseText, NebraskaColors }
}

})